<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <el-form class="top-search-form" inline :model="query">
                    <el-form-item>
                        <el-button type="primary" @click="showEditHotel({})">添加商户</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="query.id" placeholder="请输入ID" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="query.brand_id" clearable filterable placeholder="按公司查找">
                            <el-option v-for="item in companyList" :key="item.id" :label="item.title"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="query.city_id" @change="getAreaList" filterable clearable
                            placeholder="按城市查找">
                            <el-option v-for="item in cityList" :key="item.id" :label="item.title"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="query.area_id" clearable filterable placeholder="按区域查找">
                            <el-option v-for="item in areaList" :key="item.id" :label="item.shortname"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="query.title" placeholder="请输入酒店名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="btn-search" type="primary" @click="handleSearch">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item>
                            <el-switch v-model="query.is_valid" active-text="只看上线" inactive-text="只看下线" active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="hs-table-list">
            <el-table :data="tableData" v-loading="loading" style="width: 100%" :height="tableHeight"
                :max-height="tableHeight" border>
                <el-table-column prop="id" label="ID" width="100"></el-table-column>
                <el-table-column prop="company.title" show-overflow-tooltip label="归属公司" width="200"></el-table-column>
                <el-table-column prop="title" show-overflow-tooltip label="商户名称"></el-table-column>
                <el-table-column prop="city.shortname" label="城市" width="120" align="center"></el-table-column>
                <el-table-column prop="zone.shortname" label="区域" width="120" align="center"></el-table-column>
                <el-table-column label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.is_valid == 1" type="primary">在线</el-tag>
                        <el-tag v-else type="primary">下线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序" width="100" align="center"></el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="180" align="center"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="primary" @click="showEditHotel(scope.row)">编辑</el-button>
                            <el-button type="primary" @click="showHotelHall(scope.row)">宴会厅</el-button>
                            <el-button type="primary" @click="showHotelStaff(scope.row)">销售管理</el-button>
                            <el-button type="warning" @click="showBusinessStaff(scope.row)">商户管理</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="footer-box">
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    layout="total, sizes, prev, pager, next, jumper" :current-page="currentPage"
                    :page-sizes="[15, 30, 50, 100]" :page-size="pagination.limit"
                    :total="pagination.total"></el-pagination>
            </div>
        </div>
        <!-- 编辑门店信息 -->
        <edit-hotel ref="editHotel" :companyList="companyList" :cityList="cityList" :parent="_self"></edit-hotel>
        <!-- 门店厅管理 -->
        <hotel-hall ref="hotelHall"></hotel-hall>
        <!-- 绑定门店销售 -->
        <hotel-staff ref="hotelStaff"></hotel-staff>
        <business-staff ref="businessStaff"></business-staff>
    </div>
</template>

<script>
import dictionary from '@/utils/dictionary.js';
// 添加、编辑门店详情
import editHotel from './hotel/edit';
// 厅管理
import hotelHall from './hall/index';
// 门店的销售管理
import hotelStaff from './staff/index';

// 门店的商户员工管理
import businessStaff from './businessStaff/index';

export default {
    components: {
        editHotel,
        hotelHall,
        hotelStaff,
        businessStaff
    },
    data() {
        // box-sizing:border-box height不包含margin的高度
        let tableHeight = window.innerHeight - 245;
        let companyList = dictionary.getPicker('company');
        let cityList = dictionary.getPicker('city');

        return {
            companyList: companyList, // 公司列表
            cityList: cityList, // 城市列表
            areaList: [],

            currentPage: 1,
            total: '',
            tableHeight: tableHeight,
            query: {
                id: '',
                title: '',
                city_id: '',
                area_id: '',
                brand_id: '',
                is_valid: '1'
            },
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },

            tableData: [],
            loading: false,
        };
    },
    created() {
        // 获取门店列表
        this.getTableData();
    },
    methods: {
        handleSearch() {
            this.pagination.page = 1;
            this.getTableData();
        },
        getTableData() {
            let url = '/api/dictionary.hotel/index';
            let query = this.query;
            query['pagination'] = this.pagination;
            this.loading = true;
            this.$post(url, query).then(res => {
                this.tableData = res.data.list;
                this.pagination = res.data.pagination;
                this.loading = false;
            });
        },
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },

        getAreaList(e) {
            let url = '/api/dictionary.region/getAreaList';
            this.$post(url, {
                id: e
            }).then(res => {
                this.areaList = res.data.areaList;
            });
        },
        // 显示添加、编辑门店窗口
        showEditHotel(row) {
            if (this.$refs['editHotel']) {
                this.$refs['editHotel'].show(row);
            } else {
                this.$nextTick(function () {
                    this.$refs['editHotel'].show(row);
                })
            }
        },
        // 管理门店的销售
        showHotelStaff(row) {
            if (this.$refs['hotelStaff']) {
                this.$refs['hotelStaff'].show(row);
            } else {
                this.$nextTick(function () {
                    this.$refs['hotelStaff'].show(row);
                })
            }
        },
        // 管理商户员工管理
        showBusinessStaff(row) {
            if (this.$refs['businessStaff']) {
                this.$refs['businessStaff'].show(row);
            } else {
                this.$nextTick(function () {
                    this.$refs['businessStaff'].show(row);
                })
            }
        },
        // 管理门店的厅
        showHotelHall(row) {
            if (this.$refs['hotelHall']) {
                this.$refs['hotelHall'].show(row);
            } else {
                this.$nextTick(function () {
                    this.$refs['hotelHall'].show(row);
                })
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.top-search-form {
    /deep/ .el-form-item {
        margin-bottom: 0;
    }
}
</style>
